import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 1rem;
    font-size: 16px;
    
    > img {
        margin: 0 auto;
    }
`